import useContactTypes from "@/internal/composables/useContactTypes";
import { filter } from "lodash";
import { computed } from "vue";
import useHotelCredit from "./useHotelCredit";

const useHotelVerifyCredit = (id: number | string) => {
  const { data } = useHotelCredit({
    immediate: true,
    params: {
      id: id,
    },
    config: {
      errorHandling: false,
    },
  });

  const { contactTypes } = useContactTypes({
    immediate: true,
  });

  const filteredContactsType = computed(() => {
    return contactTypes.value?.filter((contactType) => {
      if (!data.value || data.value.deleted) {
        return contactType.name !== "Cartas Garantia";
      } else {
        return contactType;
      }
    });
  });

  return {
    filteredContactsType,
  };
};

export default useHotelVerifyCredit;
